__turbopack_context__.v({
  "benefits": "style-module-scss-module__n-pWza__benefits",
  "benefits__head": "style-module-scss-module__n-pWza__benefits__head",
  "benefits__head_title": "style-module-scss-module__n-pWza__benefits__head_title",
  "benefits__item": "style-module-scss-module__n-pWza__benefits__item",
  "benefits__item_illustration": "style-module-scss-module__n-pWza__benefits__item_illustration",
  "benefits__item_subtitle": "style-module-scss-module__n-pWza__benefits__item_subtitle",
  "benefits__item_title": "style-module-scss-module__n-pWza__benefits__item_title",
  "benefits__list": "style-module-scss-module__n-pWza__benefits__list",
  "benefits__subtitle": "style-module-scss-module__n-pWza__benefits__subtitle",
  "benefits__title": "style-module-scss-module__n-pWza__benefits__title",
  "button_primary": "style-module-scss-module__n-pWza__button_primary",
  "features": "style-module-scss-module__n-pWza__features",
  "features__background": "style-module-scss-module__n-pWza__features__background",
  "features__container": "style-module-scss-module__n-pWza__features__container",
  "features__content": "style-module-scss-module__n-pWza__features__content",
  "features__content_container": "style-module-scss-module__n-pWza__features__content_container",
  "features__content_cta": "style-module-scss-module__n-pWza__features__content_cta",
  "features__content_head": "style-module-scss-module__n-pWza__features__content_head",
  "features__content_img": "style-module-scss-module__n-pWza__features__content_img",
  "features__content_subtitle": "style-module-scss-module__n-pWza__features__content_subtitle",
  "features__content_swap": "style-module-scss-module__n-pWza__features__content_swap",
  "features__content_title": "style-module-scss-module__n-pWza__features__content_title",
  "features__head": "style-module-scss-module__n-pWza__features__head",
  "features__infos": "style-module-scss-module__n-pWza__features__infos",
  "features__infos_item": "style-module-scss-module__n-pWza__features__infos_item",
  "features__subtitle": "style-module-scss-module__n-pWza__features__subtitle",
  "features__title": "style-module-scss-module__n-pWza__features__title",
  "field__input": "style-module-scss-module__n-pWza__field__input",
  "flex-center-col-content": "style-module-scss-module__n-pWza__flex-center-col-content",
  "footer": "style-module-scss-module__n-pWza__footer",
  "footer__content": "style-module-scss-module__n-pWza__footer__content",
  "footer__content_left": "style-module-scss-module__n-pWza__footer__content_left",
  "footer__content_right": "style-module-scss-module__n-pWza__footer__content_right",
  "footer__cta": "style-module-scss-module__n-pWza__footer__cta",
  "footer__tagline": "style-module-scss-module__n-pWza__footer__tagline",
  "introduction": "style-module-scss-module__n-pWza__introduction",
  "introduction__background": "style-module-scss-module__n-pWza__introduction__background",
  "introduction__content": "style-module-scss-module__n-pWza__introduction__content",
  "introduction__infos": "style-module-scss-module__n-pWza__introduction__infos",
  "introduction__infos_item": "style-module-scss-module__n-pWza__introduction__infos_item",
  "lead": "style-module-scss-module__n-pWza__lead",
  "lead__content": "style-module-scss-module__n-pWza__lead__content",
  "lead__content_form": "style-module-scss-module__n-pWza__lead__content_form",
  "lead__content_form_success": "style-module-scss-module__n-pWza__lead__content_form_success",
  "lead__content_form_success_cta": "style-module-scss-module__n-pWza__lead__content_form_success_cta",
  "lead__content_form_success_subtitle": "style-module-scss-module__n-pWza__lead__content_form_success_subtitle",
  "lead__content_form_success_title": "style-module-scss-module__n-pWza__lead__content_form_success_title",
  "lead__content_image": "style-module-scss-module__n-pWza__lead__content_image",
  "lead__head": "style-module-scss-module__n-pWza__lead__head",
  "lead__head_title": "style-module-scss-module__n-pWza__lead__head_title",
  "sales": "style-module-scss-module__n-pWza__sales",
  "sales__content": "style-module-scss-module__n-pWza__sales__content",
  "sales__content_form": "style-module-scss-module__n-pWza__sales__content_form",
  "sales__content_form_success": "style-module-scss-module__n-pWza__sales__content_form_success",
  "sales__content_form_success_cta": "style-module-scss-module__n-pWza__sales__content_form_success_cta",
  "sales__content_form_success_subtitle": "style-module-scss-module__n-pWza__sales__content_form_success_subtitle",
  "sales__content_form_success_title": "style-module-scss-module__n-pWza__sales__content_form_success_title",
  "sales__content_image": "style-module-scss-module__n-pWza__sales__content_image",
  "sales__head": "style-module-scss-module__n-pWza__sales__head",
  "sales__head_title": "style-module-scss-module__n-pWza__sales__head_title",
  "tagline": "style-module-scss-module__n-pWza__tagline",
  "tagline__background": "style-module-scss-module__n-pWza__tagline__background",
  "tagline__content": "style-module-scss-module__n-pWza__tagline__content",
  "tagline__content_cta": "style-module-scss-module__n-pWza__tagline__content_cta",
  "text_button": "style-module-scss-module__n-pWza__text_button",
  "text_gradient_primary": "style-module-scss-module__n-pWza__text_gradient_primary",
  "text_heading_1": "style-module-scss-module__n-pWza__text_heading_1",
  "text_subtitle": "style-module-scss-module__n-pWza__text_subtitle",
  "text_super": "style-module-scss-module__n-pWza__text_super",
});
